import type { ReactNode } from "react";
import { Typography } from "@circle-react-uikit/Typography";

interface CustomFormItemProps {
  children: ReactNode;
  label?: string;
}

export const CustomFormItem = ({
  label = "",
  children,
}: CustomFormItemProps) => (
  <div className="flex w-full flex-col pt-6">
    <div className="pb-2">
      <Typography.LabelSm weight="semibold">{label}</Typography.LabelSm>
    </div>
    {children}
  </div>
);
